import { render, staticRenderFns } from "./dictManage.vue?vue&type=template&id=02cd5ea5&"
import script from "./dictManage.vue?vue&type=script&lang=js&"
export * from "./dictManage.vue?vue&type=script&lang=js&"
import style0 from "./dictManage.vue?vue&type=style&index=0&id=02cd5ea5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports